module.exports = __webpack_public_path__ + "static/media/icon_6.7d2dccb7.svg";